let setSavedSearches = (state, response) => {
	state.savedSearches = [];
	state.autoSearches = [];
	if (response) state.savedSearches = state.savedSearches.concat(response);
	response.forEach(search => {
		if (search.autoSearch && search.mainMenu) state.autoSearches.push(search);
	});
	state.savedSearches.push({
		id: -1,
		labelKey: 'resetSearch',
	});
};

let updateSavedSearch = (state, savedSearch) => {
	state.savedSearches = state.savedSearches.filter(item => item.id !== savedSearch.id);
	state.savedSearches.push(savedSearch);
};

let setAutoSearches = (state) => {
	state.autoSearches = [];
	state.savedSearches.forEach( search => {
		if (search.autoSearch && search.mainMenu) state.autoSearches.push(search);
	});
};

let setTripsCount = (state, { id, tripsCount }) => {
	let savedSearch = state.savedSearches.find(x => x.id === id);
	savedSearch.count = tripsCount;
};

let set = (state, fn) => {
	if (fn)
		fn(state);
};

export default {
	setSavedSearches,
	setAutoSearches,
	setTripsCount,
	updateSavedSearch,
	set
};